import { render, staticRenderFns } from "./policeInfo.vue?vue&type=template&id=4508e297&scoped=true"
import script from "./policeInfo.vue?vue&type=script&lang=js"
export * from "./policeInfo.vue?vue&type=script&lang=js"
import style0 from "./policeInfo.vue?vue&type=style&index=0&id=4508e297&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4508e297",
  null
  
)

export default component.exports